import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {ActivityAwardItem} from '../../type';
import globalStore from '@/services/global.state';
import {toPriceStr} from '@/utils';

interface RewardsCardProps {
  awardList: ActivityAwardItem[];
}

const formatAmount = (value?: number) =>
  toPriceStr(Number(value) || 0, {
    fixed: 0,
    maxFixed: 2,
    showCurrency: false,
  });

const RewardsCard = ({awardList}: RewardsCardProps) => {
  const {t} = useTranslation();
  const rows = useMemo(
    () =>
      awardList
        .map((item, index) => ({item, index}))
        .sort(
          (a, b) =>
            (Number(a.item.sort) || a.index + 1) -
            (Number(b.item.sort) || b.index + 1),
        )
        .map(({item, index}) => ({
          level: item.sort || index + 1,
          bettingAmount: `${globalStore.currency}${formatAmount(
            item.minAmount,
          )}-${globalStore.currency}${formatAmount(item.maxAmount)}`,
          bettingReward:
            item.valueType === 'PERCENT_VALUE'
              ? `${formatAmount(item.value)}%`
              : `${globalStore.currency}${formatAmount(item.value)}`,
        })),
    [awardList],
  );

  return (
    <div className="mx-4 bg-white rounded-xl flex flex-col p-3 gap-3 mb-2">
      <div className="flex flex-row items-center gap-2">
        <div className="w-1 h-3 bg-c1" />
        <div className="text-t1 text-sm font-bold capitalize">
          {t('promotionsV2.eventRewards')}
        </div>
      </div>
      <div className={'flex flex-col flex-1 text-t2 text-sm font-bold'}>
        <table className="w-full">
          <thead className="text-xs bg-[#C6D5E1] capitalize">
            <tr>
              <th className="text-center py-2">
                {t('promotionsV2.rewardTable.level')}
              </th>
              <th className="text-center py-2">
                {t('promotionsV2.rewardTable.bettingAmount')}
              </th>
              <th className="text-center py-2">
                {t('promotionsV2.rewardTable.bettingReward')}
              </th>
            </tr>
          </thead>
          <tbody>
            {rows.map(row => (
              <tr
                key={row.level}
                className="bg-[#F3F9FF] odd:bg-[#E3F1FD] divide-x divide-[#C6D5E1]">
                <td className="text-center py-2">{row.level}</td>
                <td className="text-center py-2">{row.bettingAmount}</td>
                <td className="text-center py-2">{row.bettingReward}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RewardsCard;
